import { CanvasLayoutView } from '@qpr/canvas-layout';
import { CanvasLayoutProps } from '@qpr/canvas-layout/views/CanvasLayoutView';
import React from 'react';
import { useParams } from 'react-router-dom';

const CanvasLayout = () => {
  const { containerId } = useParams<CanvasLayoutProps>();

  return <CanvasLayoutView containerId={containerId} />;
};

export default CanvasLayout;
